/* Step 11b-1a (owner 31-Oct-2026) — EN + AR texts.
   s11bPick  item 2 (N1): the searchable engagement picker (components/EngagementPicker.jsx) — the search box, the "Recent" /
             "All engagements" headings, the no-match line, the count and the keys hint. */
export default {
  en: {
    s11bPick: {
      search: "Type a client, engagement, reference or FY…",
      recent: "Recent",
      all: "All engagements",
      none: "No engagement matches “{q}”",
      noEngagements: "No engagements yet",
      count: "{n} of {total}",
      keys: "↑ ↓ move · Enter open · Esc close",
    },
  },
  ar: {
    s11bPick: {
      search: "اكتب اسم العميل أو المهمة أو المرجع أو السنة المالية…",
      recent: "الأخيرة",
      all: "جميع المهام",
      none: "لا توجد مهمة تطابق «{q}»",
      noEngagements: "لا توجد مهام بعد",
      count: "{n} من {total}",
      keys: "↑ ↓ للتنقل · Enter للفتح · Esc للإغلاق",
    },
  },
};
